const state = {
  isAuthenticated: false,
  userInfo: null,
  isAdmin: false,
};
export default state;
